import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var store = {};

var LinkInformation =
/*#__PURE__*/
function () {
  function LinkInformation(a, b, c) {
    _classCallCheck(this, LinkInformation);

    this.items = {}, this.root = a, this.parent = b, c ? this.level = this.parent.link.level + 1 : (store[a.id] = [{}], this.level = 0);
  }

  _createClass(LinkInformation, [{
    key: "configuration",
    value: function configuration() {
      var a = store[this.root.id][this.level] || (store[this.root.id][this.level] = {});
      return a;
    }
  }]);

  return LinkInformation;
}();

export { store };
export default LinkInformation;